import { Box, VStack } from '@chakra-ui/react'
import { useMemo, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ReportFilters } from '../../components/features/reports/ReportFilters'
import { useReports } from '../../hooks/useReports'

export function PayoutReportsLayout() {
  const {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    totalDays,
    payoutData,
    loading,
  } = useReports()

  const [selectedProperty, setSelectedProperty] = useState<string | undefined>(
    undefined
  )

  const filteredPayoutData = useMemo(() => {
    if (selectedProperty === undefined)
      return payoutData.sort((a, b) => (b.owner_name < a.owner_name ? 1 : -1))
    return payoutData.filter((report) =>
      report.properties.some((property) => property.id === selectedProperty)
    )
  }, [selectedProperty, payoutData])

  return (
    <>
      <VStack spacing={{ base: 6, md: 8 }} align="stretch">
        <Box px={{ base: 2, md: 6 }} mt={{ base: 2, md: 6 }}>
          <ReportFilters
            startDate={startDate}
            endDate={endDate}
            totalDays={totalDays}
            payoutData={payoutData}
            selectedProperty={selectedProperty}
            setSelectedProperty={setSelectedProperty}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
          />
        </Box>
        <Outlet
          context={{
            startDate,
            endDate,
            setStartDate,
            setEndDate,
            totalDays,
            payoutData: filteredPayoutData,
            loading,
          }}
        />
      </VStack>
    </>
  )
}
